import * as types from '../mutation-types'

const state = {
  added: [],
  checkoutStatus: null,
  info: {},
  result: {},
  tag: false
}

// getters
const getters = {
  checkoutStatus: state => state.checkoutStatus
}

// actions
const actions = {
  checkout ({ commit, state }, products) {
    commit(types.SET_CHECKOUT_STATUS, null)
    // empty cart
    commit(types.SET_CART_ITEMS, { items: [] })
  }
}

// mutations
const mutations = {
  [types.ADD_TO_CART] (state, { id }) {
    state.checkoutStatus = null
    const record = state.added.find(product => product.id === id)
    if (!record) {
      state.added.push({
        id,
        quantity: 1
      })
    } else {
      record.quantity++
    }
  },

  [types.SET_INFO] (state, status) {
    state.info = status
  },

  [types.SET_RESULT] (state, status) {
    state.result = status
  },

  [types.SET_TAG] (state, status) {
    state.tag = status
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/info.js